import { defineApi } from '#/api/define-api'
import { requestClient } from '#/api/request'

export const EXPORT_TASK_BIZ_CODE = {
  /** 账户充值/减款/清零/综合充值清零减款导出 */
  ACCOUNT_TRANSACTION: 'ads_transaction_oper_recharge',
  /** 交易明细导出 */
  ADS_TRANSACTION_OPER_TRANSFER_DETAILS:
    'ads_transaction_oper_transfer_details',
  /** 账户清零补充上传 */
  ADS_TRANSACTION_SUPPLEMENT_CLEAR_UPLOAD:
    'ads_transaction_supplement_clear_upload',
  /** 非 API 消耗补充上传 */
  ADS_ACCOUNT_SPEND_SUPPLEMENT_UPLOAD: 'ads_account_spend_supplement_upload',
  /** 广告客户表现-广告账户广告数据导出 */
  ADS_INSIGHT_ACCOUNT_DAILY: 'ads_insight_report_account_daily',
  /** 广告客户表现-Ad 导出 */
  ADS_INSIGHT_AD_DAILY: 'ads_insight_report_ad_daily',
  /** 广告客户表现-Adset 导出 */
  ADS_INSIGHT_ADSET_DAILY: 'ads_insight_report_adset_daily',
  /** 广告客户表现-Campaign 导出 */
  ADS_INSIGHT_CAMPAIGN_DAILY: 'ads_insight_report_campaign_daily',
  /** 广告客户表现-客户数据导出 */
  ADS_INSIGHT_CUSTOMER_DAILY: 'ads_insight_report_customer_daily',
  /** 广告客户表现-自定义维度导出 */
  ADS_INSIGHT_REPORT_CUSTOM_DIMENSIONS: 'ads_insight_report_custom_dimensions',
  /** 广告客户表现-Meta 多维度看板导出 */
  ADS_INSIGHT_REPORT_META_BREAKDOWNS: 'ads_insight_report_meta_breakdowns',
  /** 广告客户表现-客户导出 */
  AD_PERFORMANCE_CUSTOMER_DAILY: 'ads_reconciliation_customer_daily',
  /** 广告客户表现-广告账户导出 */
  AD_PERFORMANCE_ACCOUNT_DAILY: 'ads_reconciliation_account_daily',
  /** 地区税费明细导出 */
  ADS_LOCATION_FEE_OPER_EXPORT: 'ads_location_fee_oper_export',
  /** 地区税费-预收池总览导出 */
  ADS_LOCATION_FEE_PREPAID_OVERVIEW_EXPORT:
    'ads_location_fee_prepaid_overview_export',
  /** 地区税费-预收池流水导出 */
  ADS_LOCATION_FEE_PREPAID_FLOW_EXPORT: 'ads_location_fee_prepaid_flow_export',
  /** 介绍人吐点结算明细导出 */
  ADS_INTRODUCER_SETTLEMENT_DETAIL: 'ads_introducer_settlement_detail',
  /** 介绍人列表导出 */
  ADS_INTRODUCER_PROFILE: 'ads_introducer_profile',
  /** 介绍人吐点结算列表导出 */
  ADS_INTRODUCER_SETTLEMENT_ORDER: 'ads_introducer_settlement_order',
  /** 客户生命周期-多客户分析导出 */
  CUSTOMER_LIFECYCLE_MULTI_CUSTOMERS: 'customer_lifecycle_multi_customers',
  /** 客户生命周期-单客户分析导出 */
  CUSTOMER_LIFECYCLE_SINGLE_DETAIL: 'customer_lifecycle_single_detail',
  /** 绑卡对账-绑卡数据导出 */
  BIND_CARD_RECONCILIATION_BIND: 'ads_reconciliation_account_card_bind',
  /** 绑卡对账-核对数据导出 */
  BIND_CARD_RECONCILIATION_CHECK: 'ads_reconciliation_slash',
  /** 额度转移记录导出 */
  ADS_SLASH_CARD_LIMIT_TRANSFER_EXPORT: 'ads_slash_card_limit_transfer_export',
  /** 客户对账日报导出 */
  CUSTOMER_STATEMENT_REPORT: 'ads_customer_statement_report',
  /** 期初数据设定导出 */
  ADS_CUSTOMER_INITIAL_SET_EXPORT: 'ads_customer_initial_set_export',
  /** 分配账户日志导出 */
  ADS_ACCOUNT_ALLOCATION_LOG: 'ads_account_allocation_log',
  /** 广告账户列表导出 */
  ADS_ACCOUNT_EXPORT: 'ads_account_export',
  /** 账户封停监控-监控记录导出 */
  ADS_ACCOUNT_STATUS_RECORD_EXPORT: 'ads_account_status_record_export',
  /** 账户封停监控-封停统计导出 */
  ADS_ACCOUNT_STATUS_WEEKLY_STATS_EXPORT:
    'ads_account_status_weekly_stats_export',
  /** 账户余额日环比异常导出 */
  ADS_ACCOUNT_BALANCE_DOD_EXPORT: 'ads_account_balance_dod_export',
  /** 其他扣费流水导出 */
  ADS_CUSTOMER_FLOW_EXPORT: 'ads_customer_flow_export',
  /** Meta 资产管理-Ad Account 导出 */
  META_ASSET_AD_ACCOUNT_EXPORT: 'meta_asset_ad_account_export',
  /** Meta 资产管理-Page 导出 */
  META_ASSET_PAGE_EXPORT: 'meta_asset_page_export',
  /** Meta 资产管理-Pixel 导出 */
  META_ASSET_PIXEL_EXPORT: 'meta_asset_pixel_export',
  /** Meta 资产管理-操作日志导出 */
  META_OPERATION_LOG_EXPORT: 'meta_operation_log_export',
  /** 权限审计日志导出 */
  PERMISSION_AUDIT_LOG: 'sys_biz_audit_log',
  /** 客户列表导出 */
  ADS_USERS_EXPORT: 'ads_users_export',
  /** 广告账户返点导出 */
  ADS_ACCOUNT_REBATE_EXPORT: 'ads_account_rebate_export',
  /** 开户管理导出 */
  ADS_OPEN_ACCOUNT_TASK_EXPORT: 'ads_open_account_task_export',
  /** 账户规则配置导出 */
  /** 当前分配导出 */
  ADS_ACCOUNT_ALLOCATION_LIST: 'ads_account_allocation_list',
  /** 服务费配置导出 */
  ADS_ACCOUNT_RATE_EXPORT: 'ads_account_rate_export',
  /** 在线充值导出 */
  ADS_TRANSACTION_OPER_WALLET_RECHARGE: 'ads_transaction_oper_wallet_recharge',
  /** 行业报表导出 */
  ADS_ACCOUNT_LOAD_URL_LOG_EXPORT: 'ads_account_load_url_log_export',
  /** 客户资金变动导出 */
  ADS_CUSTOMER_FUND_CHANGE_DAILY: 'ads_customer_fund_change_daily',
  /** 整体收支监控导出 */
  ADS_INCOME_EXPENSE_DETAIL: 'ads_income_expense_detail',
  /** 广告周-账户类型导出 */
  ADS_WEEK_REPORT_ACCOUNT_TYPE: 'ads_week_report_account_type',
  /** 广告周-行业导出 */
  ADS_WEEK_REPORT_INDUSTRY: 'ads_week_report_industry',
  /** 广告周-新增客户 Top20 导出 */
  ADS_WEEK_REPORT_CUSTOMER_CHANGE_TOP: 'ads_week_report_customer_change_top',
  /** 广告周-新数据表导出 */
  ADS_WEEK_REPORT_CUSTOMER_CHANGE_PAGE: 'ads_week_report_customer_change_page',
  /** 预充配置导出 */
  ADS_CUST_PRE_RECHARGE_CONFIG: 'ads_cust_pre_recharge_config',
  /** 消费降幅记录导出 */
  ADS_SPEND_DECLINE_RECORDS: 'ads_spend_decline_records',
  /** 邮件发送日志导出 */
  ADS_EMAIL_SEND_LOG_EXPORT: 'ads_email_send_log_export',
  /** 邮件统计-整体导出 */
  ADS_EMAIL_USAGE_OVERVIEW_EXPORT: 'ads_email_usage_overview_export',
  /** 邮件统计-商户导出 */
  ADS_EMAIL_USAGE_MERCHANT_EXPORT: 'ads_email_usage_merchant_export',
  /** 广告审核列表导出 */
  ADS_GOVERNOR_V2: 'ads_governor_v2',
  /** 广告治理-广告数据导出 */
  ADS_GOVERNOR_V2_AD_INFO_CHANGE_RECORDS:
    'ads_governor_v2_ad_info_change_records',
  /** 代理+我司数据核对-净充值对比导出 */
  AGENCY_RECON_COMPARE_EXPORT: 'agency_recon_compare_export',
}

export interface ExportTaskSubmitResponse {
  taskId?: number | string
}

export const exportTaskApi = defineApi('operation', ({ prefix }) => {
  function submitExportTask<TParams>(
    bizCode: string,
    params: TParams,
    options?: {
      orderBy?: string
      sortBy?: string
    },
  ) {
    const exportParams = params as {
      condition?: {
        orderBy?: string
        sortBy?: string
      }
      orderBy?: string
      sortBy?: string
    }

    return requestClient
      .post<ExportTaskSubmitResponse>(prefix('export/submit'), {
        bizCode,
        params,
        orderBy:
          options?.orderBy ??
          exportParams.orderBy ??
          exportParams.condition?.orderBy,
        sortBy:
          options?.sortBy ??
          exportParams.sortBy ??
          exportParams.condition?.sortBy,
      })
      .then((res) => ({
        taskId: res?.taskId,
      }))
  }

  return {
    submitExportTask,
  }
})
